import { render, staticRenderFns } from "./InvoiceLedgerSubmissionView.vue?vue&type=template&id=1db348df&scoped=true&"
import script from "./InvoiceLedgerSubmissionView.vue?vue&type=script&lang=ts&"
export * from "./InvoiceLedgerSubmissionView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db348df",
  null
  
)

export default component.exports